var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var getFocusOutlineColor = function (color, colorGradient) {
    return colorGradient[color].accentScale[5];
};
var getBackgroundColor = function (variant, color, colorGradient) {
    switch (variant) {
        case "contained":
            return {
                default: colorGradient[color].accentScale[8],
                hover: colorGradient[color].accentScale[9],
                active: colorGradient[color].accentScale[9],
            };
        case "soft":
            return {
                default: colorGradient[color].accentScale[2],
                hover: colorGradient[color].accentScale[3],
                active: colorGradient[color].accentScale[4],
            };
        case "outlined":
            return {
                default: "transparent",
                hover: "transparent",
                active: "transparent",
            };
        default:
            return {
                default: colorGradient[color].accentScale[9],
                hover: colorGradient[color].accentScale[10],
                active: colorGradient[color].accentScale[11],
            };
    }
};
var getColor = function (variant, color, colorGradient) {
    switch (variant) {
        case "contained":
            return {
                default: colorGradient[color].accentContrast,
                hover: colorGradient[color].accentContrast,
                active: colorGradient[color].accentContrast,
            };
        case "soft":
            return {
                default: colorGradient[color].accentScale[10],
                hover: colorGradient[color].accentScale[10],
                active: colorGradient[color].accentScale[10],
            };
        case "outlined":
            return {
                default: colorGradient[color].accentScale[10],
                hover: colorGradient[color].accentScale[10],
                active: colorGradient[color].accentScale[10],
            };
        default:
            return {
                default: colorGradient[color].accentContrast,
                hover: colorGradient[color].accentContrast,
                active: colorGradient[color].accentContrast,
            };
    }
};
var getPadding = function (size) {
    switch (size) {
        case "small":
            return "0.5rem 0.5rem";
        case "medium":
            return "0.5rem 0.5rem";
        case "large":
            return "1rem 1rem";
    }
};
var getBorder = function (variant, color, colorGradient) {
    if (variant === "outlined") {
        return {
            default: "1px solid ".concat(colorGradient[color].accentScale[5]),
            hover: "1px solid ".concat(colorGradient[color].accentScale[6]),
            active: "1px solid ".concat(colorGradient[color].accentScale[7]),
        };
    }
    return { default: "none", hover: "none", active: "none" };
};
var getIconSize = function (size) {
    switch (size) {
        case "small":
            return "1.25rem";
        case "medium":
            return "1.25rem";
        case "large":
            return "1.5rem";
    }
};
var StyledIconBtn = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  border-radius: 50%;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  padding: ", ";\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    border: ", ";\n    box-shadow: ", ";\n  }\n  &:focus-visible {\n  outline-offset: 2px;\n    outline: 2px solid\n      ", ";\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n    border: ", ";\n    filter: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  border-radius: 50%;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  padding: ", ";\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    border: ", ";\n    box-shadow: ", ";\n  }\n  &:focus-visible {\n  outline-offset: 2px;\n    outline: 2px solid\n      ", ";\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n    border: ", ";\n    filter: ", ";\n    box-shadow: ", ";\n  }\n"])), function (props) { return (props.$disabled ? "not-allowed" : "pointer"); }, function (props) {
    return getBackgroundColor(props.$variant, props.$color, props.$colorGradient)
        .default;
}, function (props) {
    return getColor(props.$variant, props.$color, props.$colorGradient).default;
}, function (props) {
    return getBorder(props.$variant, props.$color, props.$colorGradient).default;
}, function (props) { var _a; return getPadding((_a = props.$size) !== null && _a !== void 0 ? _a : "medium"); }, function (props) { var _a; return getIconSize((_a = props.$size) !== null && _a !== void 0 ? _a : "medium"); }, function (props) { var _a; return getIconSize((_a = props.$size) !== null && _a !== void 0 ? _a : "medium"); }, function (props) {
    return getBackgroundColor(props.$variant, props.$color, props.$colorGradient)
        .hover;
}, function (props) {
    return getColor(props.$variant, props.$color, props.$colorGradient).hover;
}, function (props) {
    return getBorder(props.$variant, props.$color, props.$colorGradient).hover;
}, function (props) {
    return props.$variant === "outlined" ? "none" : "0 2px 4px 0 rgba(0, 0, 0, 0.1)";
}, function (props) {
    return getFocusOutlineColor(props.$color, props.$colorGradient);
}, function (props) {
    return getBackgroundColor(props.$variant, props.$color, props.$colorGradient)
        .active;
}, function (props) {
    return getColor(props.$variant, props.$color, props.$colorGradient).active;
}, function (props) {
    return getBorder(props.$variant, props.$color, props.$colorGradient).active;
}, function (props) {
    return props.$variant === "contained"
        ? "brightness(0.92) saturate(1.1)"
        : "none";
}, function (props) {
    return props.$variant === "outlined" ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
});
var IconButton = forwardRef(function (_a, ref) {
    var icon = _a.icon, onClick = _a.onClick, _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.variant, variant = _c === void 0 ? "contained" : _c, _d = _a.color, color = _d === void 0 ? "primary" : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, className = _a.className;
    var colorPalette = useTheme().theme.colorPalette;
    return (_jsx(StyledIconBtn, __assign({ ref: ref, "$variant": variant, "$size": size, "$color": color, "$disabled": disabled, "aria-disabled": disabled, "$colorGradient": colorPalette, onClick: onClick, className: className }, { children: typeof icon === "string" ? (_jsx(Text, __assign({ variant: "span", size: size }, { children: icon }))) : (icon) })));
});
export default IconButton;
var templateObject_1;
